import { ReactElement } from 'react';
import { CompanyFilterChip } from 'modules/core/company/components';
import { OutletOrServiceCategoryFilterChip } from 'modules/supplier/outletOrServiceCategory/OutletOrServiceCategoryFilterChip';
import { blockStateOptions, formatOptionLabel as blockStateLabel } from '../status/BlockStateField';
import { campaignStateOptions, formatOptionLabel as campaignStateLabel } from '../status/CampaignStateField';
import { boundStateOptions } from 'configuration';
import { AgencyActivityTypesFilterChip } from './AgencyActivityTypesFilterChip';
import { useActivities } from 'components/fields/ActivityField';
import { SearchFilterInput } from 'components/filters/SearchFilterInput';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { DateFilterChip } from 'components/filters/DateFilterChip';
import { UserFilterChip } from 'components/filters/UserFilterChip';
import { FilterSeparator } from 'components/filters/FilterSeparator';

interface FilterProps {
  scope: 'campaign' | 'block';
}

const viewOptions = [
  { label: 'Managed', value: 'MANAGED' },
  { label: 'Planned', value: 'PLANNED' },
  { label: 'Managed OR Planned', value: 'MANAGED_OR_PLANNED' },
];

export function Filter({ scope }: FilterProps): ReactElement {
  return (
    <>
      <SearchFilterInput />
      <CompanyFilterChip name="related_client" label="Client or payer" />
      {scope === 'campaign' ? (
        <SelectFilterChip
          name="sums__state"
          label="State"
          isMulti
          options={campaignStateOptions}
          formatOptionLabel={campaignStateLabel}
        />
      ) : (
        <SelectFilterChip name="state" isMulti options={blockStateOptions} formatOptionLabel={blockStateLabel} />
      )}
      <DateFilterChip name="date_from" />
      <DateFilterChip name="date_to" />
      <SelectFilterChip name="view" label="Visible" options={viewOptions} />
      <FilterSeparator />
      <AgencyActivityTypesFilterChip name="type" />
      <UserFilterChip name="manager" filter={{ manage_campaign: true }} />
      <UserFilterChip name="planner" filter={{ plan_campaign_block: true }} />
      <SelectFilterChip name="sums__income_state" label="Income" options={boundStateOptions} />
      <SelectFilterChip name="sums__expense_state" label="Expense" options={boundStateOptions} />
    </>
  );
}

export function RowFilter(): ReactElement {
  const activityOptions = useActivities().map((a) => ({ value: a.id.toString(), label: a.name }));
  return (
    <>
      <SearchFilterInput />
      <CompanyFilterChip name="related_client" label="Client or payer" />
      <SelectFilterChip name="activity" options={activityOptions} />
      <OutletOrServiceCategoryFilterChip name="product__outlet_or_service_category" label="Outlet / service category" />
      <CompanyFilterChip name="provider" />
      <DateFilterChip name="date_from" />
      <DateFilterChip name="date_to" />
      <FilterSeparator />
      <SelectFilterChip name="block__state" isMulti options={blockStateOptions} formatOptionLabel={blockStateLabel} />
      <AgencyActivityTypesFilterChip name="block__type" label="Type" />
      <UserFilterChip name="manager" filter={{ manage_campaign: true }} />
      <UserFilterChip name="planner" filter={{ plan_campaign_block: true }} />
      <SelectFilterChip name="income_state" label="Income" options={boundStateOptions} />
      <SelectFilterChip name="expense_state" label="Expense" options={boundStateOptions} />
    </>
  );
}
